import React from 'react';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';

import GenericList from '@ts-core/core/components/GenericList';

import { CoreSubject } from '../../types';

import SubjectTreeItem from './SubjectTreeItem';

interface SubjectsTreeProps {
  subjects?: CoreSubject[];
  loading?: boolean;

  isSubjectOpen: (subject: CoreSubject) => boolean;
  onClickSubject: (subject: CoreSubject) => void;

  renderSubjectContent: (subject: CoreSubject) => React.ReactNode;

  level?: number;
}

const SubjectsTree = (props: SubjectsTreeProps) => {
  const { subjects, loading = false, level = 0, isSubjectOpen, onClickSubject, renderSubjectContent } = props;

  return (
    <List sx={(theme) => ({ ml: theme.spacing(Math.min(level, 2)) })}>
      <GenericList
        items={subjects}
        loading={loading}
        skeletonsCount={3}
        renderItem={(index, subject) => {
          const subSubjects = subject?.subjects || [];
          const open = subject && isSubjectOpen(subject);

          return (
            <SubjectTreeItem
              key={subject?.id || index}
              subject={subject}
              onClickSubject={onClickSubject}
              isSubjectOpen={isSubjectOpen}
              loading={loading}
            >
              <Collapse in={open} timeout="auto" unmountOnExit>
                {!subject || subSubjects.length > 0 ? (
                  <SubjectsTree
                    subjects={subSubjects}
                    level={level + 1}
                    isSubjectOpen={isSubjectOpen}
                    onClickSubject={onClickSubject}
                    loading={loading}
                    renderSubjectContent={renderSubjectContent}
                  />
                ) : (
                  <Box ml={2 * level}>{renderSubjectContent(subject)}</Box>
                )}
              </Collapse>
            </SubjectTreeItem>
          );
        }}
      />
    </List>
  );
};

export default SubjectsTree;
